"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findChat = findChat;
exports.getChat = getChat;
var _solidUi = require("solid-ui");
var _solidLogic = require("solid-logic");
var _rdflib = require("rdflib");
var _longChatPane = require("./longChatPane");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function getMe() {
  return _getMe.apply(this, arguments);
}
function _getMe() {
  _getMe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var me;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          me = _solidLogic.authn.currentUser();
          if (!(me === null)) {
            _context.next = 3;
            break;
          }
          throw new Error('Current user not found! Not logged in?');
        case 3:
          _context.next = 5;
          return _solidLogic.store.fetcher.load(me.doc());
        case 5:
          return _context.abrupt("return", me);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getMe.apply(this, arguments);
}
function getPodRoot(_x) {
  return _getPodRoot.apply(this, arguments);
}
function _getPodRoot() {
  _getPodRoot = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(me) {
    var podRoot;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          podRoot = _solidLogic.store.any(me, _solidUi.ns.space('storage'), undefined, me.doc());
          if (podRoot) {
            _context2.next = 3;
            break;
          }
          throw new Error('Current user pod root not found!');
        case 3:
          return _context2.abrupt("return", podRoot);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getPodRoot.apply(this, arguments);
}
function sendInvite(_x2, _x3) {
  return _sendInvite.apply(this, arguments);
}
function _sendInvite() {
  _sendInvite = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(invitee, chatThing) {
    var inviteeInbox, inviteBody, inviteResponse, locationStr;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return _solidLogic.store.fetcher.load(invitee.doc());
        case 2:
          inviteeInbox = _solidLogic.store.any(invitee, _solidUi.ns.ldp('inbox'), undefined, invitee.doc());
          if (inviteeInbox) {
            _context3.next = 5;
            break;
          }
          throw new Error("Invitee inbox not found! ".concat(invitee.value));
        case 5:
          inviteBody = "\n<> a <http://www.w3.org/ns/pim/meeting#LongChatInvite> ;\n".concat(_solidUi.ns.rdf('seeAlso'), " <").concat(chatThing.value, "> . \n  ");
          _context3.next = 8;
          return _solidLogic.store.fetcher.webOperation('POST', inviteeInbox.value, {
            data: inviteBody,
            contentType: 'text/turtle'
          });
        case 8:
          inviteResponse = _context3.sent;
          locationStr = inviteResponse.headers.get('location');
          if (locationStr) {
            _context3.next = 12;
            break;
          }
          throw new Error("Invite sending returned a ".concat(inviteResponse.status));
        case 12:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _sendInvite.apply(this, arguments);
}
function determineChatContainer(invitee, podRoot) {
  // Create chat
  // See https://gitter.im/solid/chat-app?at=5f3c800f855be416a23ae74a
  var chatContainerStr = new URL("IndividualChats/".concat(new URL(invitee.value).host, "/"), podRoot.value).toString();
  return new _rdflib.NamedNode(chatContainerStr);
}
function createChatThing(_x4, _x5) {
  return _createChatThing.apply(this, arguments);
}
function _createChatThing() {
  _createChatThing = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(chatContainer, me) {
    var created;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return _longChatPane.longChatPane.mintNew({
            session: {
              store: _solidLogic.store
            }
          }, {
            me: me,
            newBase: chatContainer.value
          });
        case 2:
          created = _context4.sent;
          return _context4.abrupt("return", created.newInstance);
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _createChatThing.apply(this, arguments);
}
function setAcl(_x6, _x7, _x8) {
  return _setAcl.apply(this, arguments);
}
function _setAcl() {
  _setAcl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(chatContainer, me, invitee) {
    var chatAclDoc, aclBody, aclResponse;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return _solidLogic.store.fetcher.load(chatContainer);
        case 2:
          // FIXME: check the Why value on this quad:
          chatAclDoc = _solidLogic.store.any(chatContainer, new _rdflib.NamedNode('http://www.iana.org/assignments/link-relations/acl'));
          if (chatAclDoc) {
            _context5.next = 5;
            break;
          }
          throw new Error('Chat ACL doc not found!');
        case 5:
          aclBody = "\n@prefix acl: <http://www.w3.org/ns/auth/acl#>.\n<#owner>\n    a acl:Authorization;\n    acl:agent <".concat(me.value, ">;\n    acl:accessTo <.>;\n    acl:default <.>;\n    acl:mode\n        acl:Read, acl:Write, acl:Control.\n<#invitee>\n    a acl:Authorization;\n    acl:agent <").concat(invitee.value, ">;\n    acl:accessTo <.>;\n    acl:default <.>;\n    acl:mode\n        acl:Read, acl:Append.\n");
          _context5.next = 8;
          return _solidLogic.store.fetcher.webOperation('PUT', chatAclDoc.value, {
            data: aclBody,
            contentType: 'text/turtle'
          });
        case 8:
          aclResponse = _context5.sent;
        case 9:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _setAcl.apply(this, arguments);
}
function addToPrivateTypeIndex(_x9, _x10) {
  return _addToPrivateTypeIndex.apply(this, arguments);
}
function _addToPrivateTypeIndex() {
  _addToPrivateTypeIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(chatThing, me) {
    var privateTypeIndex, reg, ins;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          // Add to private type index
          privateTypeIndex = _solidLogic.store.any(me, _solidUi.ns.solid('privateTypeIndex'));
          if (privateTypeIndex) {
            _context6.next = 3;
            break;
          }
          throw new Error('Private type index not found!');
        case 3:
          _context6.next = 5;
          return _solidLogic.store.fetcher.load(privateTypeIndex);
        case 5:
          reg = _solidUi.widgets.newThing(privateTypeIndex);
          ins = [(0, _rdflib.st)(reg, _solidUi.ns.rdf('type'), _solidUi.ns.solid('TypeRegistration'), privateTypeIndex.doc()), (0, _rdflib.st)(reg, _solidUi.ns.solid('forClass'), _solidUi.ns.meeting('LongChat'), privateTypeIndex.doc()), (0, _rdflib.st)(reg, _solidUi.ns.solid('instance'), chatThing, privateTypeIndex.doc())];
          _context6.next = 9;
          return new Promise(function (resolve, reject) {
            _solidLogic.store.updater.update([], ins, function (_uri, ok, errm) {
              if (!ok) {
                reject(new Error(errm));
              } else {
                resolve();
              }
            });
          });
        case 9:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _addToPrivateTypeIndex.apply(this, arguments);
}
function findChat(_x11) {
  return _findChat.apply(this, arguments);
}
function _findChat() {
  _findChat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(invitee) {
    var me, podRoot, chatContainer, exists;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return getMe();
        case 2:
          me = _context7.sent;
          _context7.next = 5;
          return getPodRoot(me);
        case 5:
          podRoot = _context7.sent;
          chatContainer = determineChatContainer(invitee, podRoot);
          exists = true;
          _context7.prev = 8;
          _context7.next = 11;
          return _solidLogic.store.fetcher.load(new _rdflib.NamedNode(chatContainer.value + _longChatPane.longChatPane.CHAT_LOCATION_IN_CONTAINER));
        case 11:
          _context7.next = 16;
          break;
        case 13:
          _context7.prev = 13;
          _context7.t0 = _context7["catch"](8);
          exists = false;
        case 16:
          return _context7.abrupt("return", {
            me: me,
            chatContainer: chatContainer,
            exists: exists
          });
        case 17:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[8, 13]]);
  }));
  return _findChat.apply(this, arguments);
}
function getChat(_x12) {
  return _getChat.apply(this, arguments);
}
function _getChat() {
  _getChat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(invitee) {
    var createIfMissing,
      _yield$findChat,
      me,
      chatContainer,
      exists,
      chatThing,
      _args8 = arguments;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          createIfMissing = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : true;
          _context8.next = 3;
          return findChat(invitee);
        case 3:
          _yield$findChat = _context8.sent;
          me = _yield$findChat.me;
          chatContainer = _yield$findChat.chatContainer;
          exists = _yield$findChat.exists;
          if (!exists) {
            _context8.next = 9;
            break;
          }
          return _context8.abrupt("return", new _rdflib.NamedNode(chatContainer.value + _longChatPane.longChatPane.CHAT_LOCATION_IN_CONTAINER));
        case 9:
          if (!createIfMissing) {
            _context8.next = 20;
            break;
          }
          _context8.next = 12;
          return createChatThing(chatContainer, me);
        case 12:
          chatThing = _context8.sent;
          _context8.next = 15;
          return sendInvite(invitee, chatThing);
        case 15:
          _context8.next = 17;
          return setAcl(chatContainer, me, invitee);
        case 17:
          _context8.next = 19;
          return addToPrivateTypeIndex(chatThing, me);
        case 19:
          return _context8.abrupt("return", chatThing);
        case 20:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _getChat.apply(this, arguments);
}
//# sourceMappingURL=create.js.map